import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["type", "mobileSelect"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { SidebarNav } from '../SidebarNav';
import { Typography } from '../../components/Typography';
import { Select, OffCanvasSelect } from '../../components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var InPageNav = function InPageNav(_ref) {
  var _props$items$find;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'accordion' : _ref$type,
      mobileSelect = _ref.mobileSelect,
      props = _objectWithoutProperties(_ref, _excluded);

  var selectProps = {
    // * controlled vs uncontrolled
    onChange: (mobileSelect === null || mobileSelect === void 0 ? void 0 : mobileSelect.onChange) || function (href) {
      if (href) {
        window.location.assign(href);
      }
    },
    value: (mobileSelect === null || mobileSelect === void 0 ? void 0 : mobileSelect.value) || ((_props$items$find = props.items.find(function (item) {
      return item.title === props.defaultActiveKey;
    })) === null || _props$items$find === void 0 ? void 0 : _props$items$find.href),
    options: props.items.map(function (item) {
      return {
        id: item.id || item.href,
        name: item.title
      };
    })
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SidebarNav, _objectSpread({
      className: "in-page-nav large-mb d-none d-lg-block border-end border-default-active",
      collapsible: type == 'accordion'
    }, props)), /*#__PURE__*/_jsxs("div", {
      className: "border-bottom border-default-active pb-600 mb-600 d-lg-none",
      children: [/*#__PURE__*/_jsx(Typography, {
        className: "mb-200",
        type: "sub-heading-1",
        children: props.title
      }), /*#__PURE__*/_jsx("div", {
        className: "d-none d-sm-block",
        children: /*#__PURE__*/_jsx(Select, _objectSpread({
          className: "mw-100 w-auto my-100"
        }, selectProps))
      }), /*#__PURE__*/_jsx("div", {
        className: "d-block d-sm-none",
        children: /*#__PURE__*/_jsx(OffCanvasSelect, _objectSpread({
          title: "Table of contents"
        }, selectProps))
      })]
    })]
  });
};

export default InPageNav;